<template>
    <router-view :key="this.$route.path" />
</template>